import { render, staticRenderFns } from "./AddTournamentPlace.vue?vue&type=template&id=ba3d08fa"
import script from "./AddTournamentPlace.vue?vue&type=script&lang=js"
export * from "./AddTournamentPlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports